declare var Rellax: any;
declare var _sr: any;

import { Component, OnInit } from '@angular/core';
import { DataService } from '../services/dataService.service';

@Component({
  selector: 'app-start',
  templateUrl: './start.component.html',
  styleUrls: ['./start.component.scss'],
})
export class StartComponent implements OnInit {

    static componentName = 'StartComponent';
    cases: any;
    show = 11;

    constructor(
        private dataService: DataService,
    ) {}

    getCases(): void {
        this.dataService.getPosts('cases', false)
            .subscribe(res => this.convertPostsObject(res));
    }

    convertPostsObject(res): void {
        this.cases = Object.keys(res).map(function(resNamedIndex) {
            return res[resNamedIndex];
        });

        if (this.cases.length % 2 === 0) {
            this.show = 10;
        }

        setTimeout(() => {
            _sr.reveal('.case-puff h2.case-title',
                {
                    reset: true,
                    scale: 1,
                    opacity: 0.3,
                    duration: 0,
                    distance: 0,
                    easing: 'ease-in-out',
                    afterReveal: function(domEl) {
                        domEl.parentNode.parentNode.classList.add('in-view');
                        for (const el in document.querySelectorAll('.case-puff')) {
                            if (document.querySelectorAll('.case-puff').hasOwnProperty(el)) {
                                document.querySelectorAll('.case-puff')[el].classList.add('fade-in');
                            }
                        }
                    },
                    afterReset: function(domEl) {
                        domEl.parentNode.parentNode.classList.remove('in-view');
                    }
                }
            );
        }, 1000);
    }

    showAllCases() {
        const hiddenPuffs = document.querySelectorAll('.case-puff.hidden');
        document.querySelectorAll('.more-case-button')[0].remove();
        for (const puff in hiddenPuffs) {
            if (hiddenPuffs.hasOwnProperty(puff)) {
                hiddenPuffs[puff].classList.remove('hidden');
            }
        }

        if (typeof window !== 'undefined') {
            window.dispatchEvent(new Event('resize'));
        }
    }

    ngOnInit() {
        this.getCases();

        setTimeout(() => {
            const rellax = new Rellax('.rellax');
        }, 700);
    }

}



// WEBPACK FOOTER //
// E:/MBP/BloomyNG/src/app/start/start.component.ts